module.exports = __webpack_public_path__ + "static/section-img-3802c82a55d87f29252ee5b0d54a1f40.png";